import React from "react";
import "./SpectatorPanel.css";

const REACT_EMOJIS = ["🔥", "👏", "😮", "💀", "🎲", "👑"];

export default function SpectatorPanel({ count, isSpectator, onReact }) {
  return (
    <>
      {count > 0 && (
        <div className="spectatorCountBadge" aria-live="polite">
          👀 {count} watching
        </div>
      )}

      {isSpectator && (
        <>
          <div className="spectatorModeBanner">👁️ Spectator mode — watch only</div>
          <div className="spectatorReactionBar">
            {REACT_EMOJIS.map((emoji) => (
              <button
                key={emoji}
                className="spectatorReactionBtn"
                onClick={() => onReact(emoji)}
                aria-label={`React ${emoji}`}
              >
                {emoji}
              </button>
            ))}
          </div>
        </>
      )}
    </>
  );
}
